import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FinancialOverview, TransactionResponse } from '../Models/Transcations';

@Injectable({
  providedIn: 'root'
})
export class TransacationServiceService {

constructor(private http:HttpClient) { }
  
    baseurl=`${environment.baseUrl}`

      private baseUrl = `${environment.baseUrl}`; // ✅ Base URL from environment
  private apiUrl = `${this.baseUrl}/transaction/report`;

    getAllTransactions(searchText: string = '', pageNumber: number = 1, pageSize: number = 10,type: string = '', datefilter: string = ''  ) {
      return this.http.get<TransactionResponse>(`${this.baseurl}/transaction/history?searchText=${searchText}&TransacationType=${type}&datefilter=${datefilter}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
    }

    getFinancialOverview(dateFilter: string ) {
      debugger
      return this.http.get<FinancialOverview>(`${this.baseurl}/transaction/dashboard?filter=${dateFilter}`);
    }


downloadFinancialReport(
    searchText?: string,
    transactionType?: string,
    dateFilter?: string,
    pageNumber: number = 1,
    pageSize: number = 10
  ): void {
    const params = new HttpParams()
      .set('searchText', searchText || '')
      .set('TransacationType', transactionType || '')
      .set('datefilter', dateFilter || '')
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize);

    this.http.get(this.apiUrl, {
      params,
      responseType: 'blob' 
    }).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'FinancialOverview.pdf';
        anchor.click();
        window.URL.revokeObjectURL(url);
      },
      error: err => {
        console.error('Failed to download financial report:', err);
      }
    });

    
}}
